import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
const routes = [
  //0 超管 //1 渠道商  //2 项目
  {
    path: "/",
    name: "login",
    component: () => import("../views/login/login.vue"),
  },
  {
    path: "/mainPage",
    name: "mainPage",
    meta: {
      title: "首页",
    },
    component: () => import("../views/mainPage/mainPage.vue"),
    redirect: () => {
      let routerPath = "/mainPage";
      let role = JSON.parse(localStorage.getItem("SET_DATA")).accountCategory;
      role == 0
        ? (routerPath += "/accountManagement")
        : role == 1
        ? (routerPath += "/partnerPM")
        : (routerPath += "/menuPage");
      return routerPath;
    },
    children: [
      {
        path: "roleManagement",
        name: "roleManagement",
        meta: {
          title: "角色管理",
          visiable: true,
          role: ["0", "1", "2"],
        },
        component: () => import("../components/SuperTube/roleManagement"),
      },
      {
        path: "accountManagement",
        name: "accountManagement",
        meta: {
          title: "账号管理",
          visiable: true,
          role: ["0"],
        },
        component: () => import("../components/SuperTube/accountManagement"),
      },
      {
        path: "menuManagement",
        name: "menuManagement",
        meta: {
          title: "菜单管理",
          visiable: true,
          role: ["0"],
        },
        component: () => import("../components/SuperTube/menuManagement"),
      },
      {
        path: "channelManagement",
        name: "channelManagement",
        meta: {
          title: "渠道商管理",
          visiable: true,
          role: ["0"],
        },
        component: () => import("../components/SuperTube/channelManagement"),
      },
      {
        path: "DockingPlatform",
        name: "DockingPlatform",
        meta: {
          title: "平台对接",
          visiable: true,
          role: ["0"],
        },
        component: () => import("../components/SuperTube/DockingPlatform"),
      },
      //*渠道合作商
      {
        path: "partnerPM",
        name: "partnerPM",
        meta: {
          title: "项目账号管理",
          visiable: true,
          role: ["1"],
        },
        component: () => import("../components/distributor/partnerPM"),
      },
      {
        path: "partnerPMname",
        name: "partnerPMname",
        meta: {
          title: "项目管理",
          visiable: true,
          role: ["0", "1"],
        },
        component: () => import("../components/distributor/partnerPMname"),
      },
      {
        path: "deviceManager",
        name: "deviceManager",
        meta: {
          title: "设备查询管理",
          visiable: true,
          role: ["0", "1"],
        },
        component: () => import("../components/distributor/deviceManager"),
      },
      // *项目账号
      {
        path: "menuPage",
        name: "menuPage",
        meta: {
          title: "菜单首页",
          visiable: true,
          role: ["0", "2"],
        },
        component: () => import("../components/ProjectAccount/menuPage.vue"),
      },
      {
        path: "BasicProjectI",
        name: "BasicProjectI",
        meta: {
          title: "项目信息",
          visiable: true,
          role: ["2"],
        },
        component: () => import("../components/ProjectAccount/BasicProjectI"),
      },
      {
        path: "xm",
        name: "xm",
        meta: {
          title: "项目信息",
          visiable: true,
          role: ["2"],
        },
        component: () => import("../components/ProjectAccount/xm"),
      },
      {
        path: "fence",
        name: "fence",
        meta: {
          title: "电子围栏",
          visiable: true,
          role: ["2"],
        },
        component: () => import("../components/ProjectAccount/fence"),
      },
      //*实名制管理
      {
        path: "capitalConstruction",
        name: "capitalConstruction",
        meta: {
          title: "参建单位",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/realNameReg/capitalConstruction"
          ),
      },
      {
        path: "teamManagement",
        name: "teamManagement",
        meta: {
          title: "班组管理",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import("../components/ProjectAccount/realNameReg/teamManagement"),
      },
      {
        path: "personnelManagement",
        name: "personnelManagement",
        meta: {
          title: "人员管理",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/realNameReg/personnelManagement"
          ),
      },
      {
        path: "personnelManagement-1",
        name: "personnelManagement-1",
        meta: {
          title: "人员管理",
          visiable: true,
          role: ["1"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/realNameReg/personnelManagement-1"
          ),
      },
      //规则设置

      {
        path: "ruleSetting",
        name: "ruleSetting",
        meta: {
          title: "规则设置",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import("../components/ProjectAccount/RuleSetting/ruleSetting.vue"),
      },
      {
        path: "forewarning",
        name: "forewarning",
        meta: {
          title: "预警记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import("../components/ProjectAccount/RuleSetting/forewarning.vue"),
      },
      //评价设置
      {
        path: "evaluationRecord",
        name: "evaluationRecord",
        meta: {
          title: "奖惩记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/EvaluationSetting/evaluationRecord.vue"
          ),
      },
      {
        path: "behaviorRecord",
        name: "behaviorRecord",
        meta: {
          title: "行为记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/EvaluationSetting/behaviorRecord.vue"
          ),
      },

      // 平台对接
      {
        path: "pushRecord",
        name: "pushRecord",
        meta: {
          title: "推送记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import("../components/ProjectAccount/PlatformDocking/pushRecord.vue"),
      },
      //安全教育
      {
        path: "trainedRecord",
        name: "trainedRecord",
        meta: {
          title: "培训记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/SafetyEducation/trainedRecord.vue"
          ),
      },
      {
        path: "untrainedRecord",
        name: "untrainedRecord",
        meta: {
          title: "未培训记录",
          visiable: true,
          role: ["2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/SafetyEducation/untrainedRecord.vue"
          ),
      },

      //*门禁考勤
      {
        path: "CardRecord",
        name: "CardRecord",
        meta: {
          title: "打卡记录",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import("../components/ProjectAccount/controlAttendance/CardRecord"),
      },
      {
        path: "AttendanceStatistics",
        name: "AttendanceStatistics",
        meta: {
          title: "考勤统计",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/controlAttendance/AttendanceStatistics"
          ),
      },
      {
        path: "AttendanceAnalysis",
        name: "AttendanceAnalysis",
        meta: {
          title: "出勤分析",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/controlAttendance/AttendanceAnalysis"
          ),
      },
      {
        path: "attendanceMonthly",
        name: "attendanceMonthly",
        meta: {
          title: "出勤月报",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/controlAttendance/attendanceMonthly"
          ),
      },
      //*设备管理
      {
        path: "CreditCardEquipment",
        name: "CreditCardEquipment",
        meta: {
          title: "刷卡设备",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/equipmentManagement/CreditCardEquipment"
          ),
      },
      {
        path: "faceDevice",
        name: "faceDevice",
        meta: {
          title: "人脸设备",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import("../components/ProjectAccount/equipmentManagement/faceDevice"),
      },
      {
        path: "faceDevice-1",
        name: "faceDevice-1",
        meta: {
          title: "人脸设备",
          visiable: true,
          role: ["1"],
        },
        component: () =>
          import(
            "../components/ProjectAccount/equipmentManagement/faceDevice-1"
          ),
      },
      {
        path: "LEDShow",
        name: "LEDShow",
        meta: {
          title: "LED显示",
          visiable: true,
          role: ["0", "2"],
        },
        component: () =>
          import("../components/ProjectAccount/equipmentManagement/LEDShow"),
      },
      {
        path: "LEDShow-1",
        name: "LEDShow-1",
        meta: {
          title: "LED显示",
          visiable: true,
          role: ["1"],
        },
        component: () =>
          import("../components/ProjectAccount/equipmentManagement/LEDShow-1"),
      },
      {
        path: "Personal",
        name: "Personal",
        meta: {
          title: "个人中心",
          visiable: true,
          role: ["0", "2"],
        },
        component: () => import("../views/Personal"),
      },
    ],
  },
];

const router = new VueRouter({
  // mode:'history',
  routes,
});
const VueRouterPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err);
};

router.beforeEach((to, from, next) => {
  //页面跳转超出部分不能出现滚动条的 解决
  document
    .querySelector("body")
    .setAttribute("style", "overflow: auto !important;");
  if (to.path === "/") return next();
  const loginToken = sessionStorage.getItem("TOKEN");
  if (!loginToken) return next("/");
  next();

  let role = localStorage.getItem("");
});
export default router;
